<script>
  export default {
    components: {},
    props: {
      title: {
        type: String,
        required: true,
      },
      list: {
        type: Array,
        default: ()=> {
          return []
        }
      },
      item: {
        type:Object,
        default: ()=> {
          return null
        }
      },
      queryString: {
        type: String,
        default: '',
      }
    },
    methods: {
      getCategoryAlias(item) {
        const name = () => {
          const result = {
            'brand-solution-item': 'brand-solution-list',
            'solution-item': 'solution-list',
            'brand-case-item': 'brand-case-list',
          }
          return result[this.$route.name]
        }
        const query = () => {
          return {
            [this.queryString]: item.alias
          }
        }
        return {
          name: name(),
          params: {...this.$route.params},
          query: query()
        }
      }
    }
  }
</script>
<template>
  <div :class="$style.solutionCategory">
    <h2 class="solutionCategory__title">{{title}}</h2>
    <div>
      <template v-if="list.length">
        <div v-for="(category, index) in list" :key="index" class="badge-gray">
          <router-link
            class="badge-gray__link"
            :to="getCategoryAlias(category)"
          >
            {{ category.title }}
          </router-link>
        </div>
      </template>
      <template v-if="item">
        <div class="badge-gray">
          <router-link
            class="badge-gray__link"
            :to="getCategoryAlias(item)"
          >
            {{ item.title }}
          </router-link>
        </div>
      </template>
    </div
    >
  </div>
</template>
<style lang="scss" module>
  .solutionCategory {
    width: 100%;
    padding-right: 3.125rem;
    padding-left: 3.125rem;
    margin-left: auto;

    @include max-lg {
      padding-right: 0;
      padding-left: 0;
    }
    // margin-bottom: 3rem;
    :global {
      .solutionCategory {
        &__title {
          margin-bottom: 1.25rem;
          font-size: 1.3125rem;
          @include max-md {
            margin-bottom: 1rem;
            font-size: 1rem;
          }
        }
      }

      .badge-gray {
        display: inline-block;
        margin-right: 0.625rem;
        margin-bottom: 1rem;
        font-size: 0.875rem;
        font-weight: 200;
        // color: $color-gray-6;

        // line-height: 1;

        background-color: rgba($color-gray-5, 10%);

        &__link {
          display: inline-block;
          padding: 0.63rem 0.8125rem;
          color: $color-gray-6;
          border-radius: 5px;
          font-weight: 400;
          &:hover {
            color: $color-primary;
            text-decoration: none;
            // background-color: rgba(140, 151, 172, 0.2);
          }
          @include max-md {
            font-size: 0.75rem;
            padding: 0.56rem 0.75rem
          }
        }

        // + .badge-gray {
        //   margin-left: 0.625rem;
        // }
      }
    }
  }
</style>
